// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YHdl","title":"Header_title__7Psi7","side":"Header_side__2WIUJ"};